import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthSocialLink } from '@nebular/auth';
import { AuthService } from '../../auth.service'
import { NbToastrService } from '@nebular/theme';
import { timeout } from 'rxjs/operators';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class RegisterComponent implements OnInit {

  ngOnInit() {
  }

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  socialLinks: NbAuthSocialLink[] = [];

  constructor(protected cd: ChangeDetectorRef,
              protected router: Router,
              private auth: AuthService,
              private toast: NbToastrService) {

    // this.redirectDelay = this.getConfigValue('forms.register.redirectDelay');
    // this.showMessages = this.getConfigValue('forms.register.showMessages');
    // this.strategy = this.getConfigValue('forms.register.strategy');
    // this.socialLinks = this.getConfigValue('forms.login.socialLinks');
  }

  async register() {
    const user = await this.auth.emailSignUp(this.user);

    if(user){
      this.toast.danger(
        user['message'],
        'Error registering user'
         );
    } else {
      this.toast.success(
        'User regitered succefully!');
        timeout(5000);
    }
    // this.errors = this.messages = [];
    // this.submitted = true;
    //
    // this.service.register(this.strategy, this.user).subscribe((result: NbAuthResult) => {
    //   this.submitted = false;
    //   if (result.isSuccess()) {
    //     this.messages = result.getMessages();
    //   } else {
    //     this.errors = result.getErrors();
    //   }
    //
    //   const redirect = result.getRedirect();
    //   if (redirect) {
    //     setTimeout(() => {
    //       return this.router.navigateByUrl(redirect);
    //     }, this.redirectDelay);
    //   }
    //   this.cd.detectChanges();
    // });
  }

  // getConfigValue(key: string): any {
  //   return getDeepFromObject(this.options, key, null);
  // }
}
